import { render, staticRenderFns } from "./canada-distribution-table.vue?vue&type=template&id=38c72ce7&"
var script = {}
import style0 from "./canada-distribution-table.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports